/**
 * Entry point — mounts React 19 app with BrowserRouter.
 * Imports i18n side-effect first so translations are ready before render.
 */
import './i18n/index'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'

const root = document.getElementById('root')
if (!root) throw new Error('[main] #root element not found')

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
